import { Inject, Injectable } from '@angular/core';
import { CommandHandlerFor, Http } from '@skylab-angular-shared/core';
import { AddDashboardNoteCommand, AddDashboardNoteCommandHandlerBase, AddDashboardNoteResponse } from '@skylab-shared/business';
import { HttpService } from '@skylab-shared/core';

@CommandHandlerFor(AddDashboardNoteCommand)
@Injectable({ providedIn: 'root'})
export class AddDashboardNoteCommandHandler {
    private commandHandler: AddDashboardNoteCommandHandlerBase;
    public constructor(
        @Inject(Http) http: HttpService
    ) {
        this.commandHandler = new AddDashboardNoteCommandHandlerBase(http);
    }

    public async handleAsync(cmd: AddDashboardNoteCommand): Promise<AddDashboardNoteResponse> {
        return await this.commandHandler.handleAsync(cmd);
    }
}
